import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FaCheckCircle, FaArrowRight, FaAward, FaUsers, FaGlobe, FaIndustry } from 'react-icons/fa';

export default function About() {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    axios.get('/api/settings').then(r => setSettings(r.data)).catch(() => {});
  }, []);

  const values = [
    { icon: FaAward, title: 'Kalite Standartları', desc: 'ISO 9001:2015 sertifikalı üretim süreçleriyle uluslararası kalite standartlarını karşılıyoruz.' },
    { icon: FaUsers, title: 'Müşteri Odaklılık', desc: 'Her müşterimizin ihtiyacına özel çözümler geliştiriyor, uzun vadeli ilişkiler kuruyoruz.' },
    { icon: FaGlobe, title: 'Global Erişim', desc: '50\'den fazla ülkeye ihracat yaparak global bir oyuncu olmayı başardık.' },
    { icon: FaIndustry, title: 'Yenilikçi Üretim', desc: 'Modern teknoloji ve yenilikçi yaklaşımlarla sektörde öncü konumdayız.' },
  ];

  const certifications = ['ISO 9001:2015', 'CE Belgesi', 'TSE Belgesi', 'FDA Onaylı Malzeme', 'ISO 14001 Çevre'];

  return (
    <div className="pt-20">
      {/* Header */}
      <div className="hero-gradient hero-pattern py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="text-sm text-gray-400 mb-4">
            <Link to="/" className="hover:text-secondary">Ana Sayfa</Link> <span className="mx-2">/</span>
            <span className="text-white">Hakkımızda</span>
          </nav>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Hakkımızda</h1>
          <p className="text-gray-300 text-lg max-w-2xl">Plastik ve ambalaj sektöründe 20 yılı aşkın deneyim</p>
        </div>
      </div>

      {/* Story */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="text-secondary font-semibold text-sm uppercase tracking-wider">Hikayemiz</span>
              <h2 className="text-3xl font-bold text-primary mt-2 mb-6">20 Yılı Aşkın Deneyim ve Güven</h2>
              <div className="text-gray-600 leading-relaxed space-y-4">
                <p>{settings.about_text || 'ENES Plastik & Ambalaj olarak 20 yılı aşkın tecrübemizle sektörde güvenilir çözümler sunmaktayız.'}</p>
                <p>Kuruluşumuzdan bu yana müşteri memnuniyetini ve ürün kalitesini her şeyin önünde tutarak büyüdük. Modern üretim tesisimiz ve uzman kadromuzla Türkiye'nin önde gelen ambalaj şirketleri arasında yer almaktayız.</p>
                <p>Sürekli AR-GE yatırımlarımız ve müşteri geri bildirimlerine dayalı gelişim anlayışımızla sektörde kalıcı bir yer edinmiş bulunmaktayız.</p>
              </div>
              <div className="mt-8 flex flex-wrap gap-3">
                {['Yenilikçi', 'Güvenilir', 'Kaliteli', 'Sürdürülebilir'].map(tag => (
                  <span key={tag} className="badge bg-primary/10 text-primary text-sm px-3 py-1.5">{tag}</span>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {[
                { value: '20+', label: 'Yıl Deneyim', bg: 'bg-primary' },
                { value: '500+', label: 'Farklı Ürün', bg: 'bg-secondary' },
                { value: '1000+', label: 'Mutlu Müşteri', bg: 'bg-primary-light' },
                { value: '50+', label: 'Ülkeye İhracat', bg: 'bg-secondary-dark' },
              ].map(stat => (
                <div key={stat.label} className={`${stat.bg} rounded-2xl p-6 text-center text-white`}>
                  <div className="text-3xl font-extrabold mb-1">{stat.value}</div>
                  <div className="text-sm opacity-80">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-secondary font-semibold text-sm uppercase tracking-wider">Değerlerimiz</span>
            <h2 className="section-title mt-2">Bizi Farklı Kılan Değerler</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map(v => (
              <div key={v.title} className="card p-6 text-center hover:-translate-y-1 transition-transform">
                <div className="w-14 h-14 bg-secondary/10 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <v.icon className="text-secondary text-2xl" />
                </div>
                <h3 className="font-semibold text-primary mb-3">{v.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <h2 className="text-2xl font-bold text-primary">Sertifikalarımız & Belgelerimiz</h2>
          </div>
          <div className="flex flex-wrap justify-center gap-4">
            {certifications.map(c => (
              <div key={c} className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-5 py-3">
                <FaCheckCircle className="text-secondary" />
                <span className="font-medium text-gray-700 text-sm">{c}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-primary">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Birlikte Çalışalım</h2>
          <p className="text-gray-300 mb-8">İhtiyaçlarınız için bizimle iletişime geçin, en uygun çözümü birlikte bulalım.</p>
          <Link to="/iletisim" className="btn-primary">
            İletişime Geçin <FaArrowRight />
          </Link>
        </div>
      </section>
    </div>
  );
}
